import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import UploadIcon from "../../Assets/img/upload.png";
import CharIcon from "../../Assets/img/word.png";
import API from "../Service/Baseservice";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import "../Services/Services.css";
import Loading from "../../Loading/loading";
import HowItWorkPreview from "./HowItWorkPreview";
const HowItWorkEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const lang = queryParams.get("lang");
  const [showPreviewHowItWork, setShowPreviewHowItWork] = useState(false);
  const [previewData, setPreviewData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [languageId, setLanguageId] = useState(lang ? Number(lang) : 1);

  const howItWorksServiceMap = {
    1: 4,  // English service_id
    2: 9,  // French service_id
  };

  const [formData, setFormData] = useState({
    howitsworks_id: "",
    language_id: languageId,
    service_id: id,
    heading: "",
    title: "",
    image: "",
    active: 1,
    updatedBy: 1,
    cards: [{
      card1: "", description1: "",
      card2: "", description2: "",
      card3: "", description3: "",
      card4: "", description4: "",
    }],
  });

  const [popup, setPopup] = useState({ show: false, title: "", message: "", type: "" });

  const getPlainTextLength = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html || "";
    return (div.textContent || div.innerText || "").length;
  };


  useEffect(() => {
    setLoading(true);

    const payload = {
      service_id: (howItWorksServiceMap[languageId]),
      language_id: languageId
    };


    API.post("howitsworksListView/condition", payload)
      .then((res) => {
        const data = res.data?.data;
        if (data) {
          const hw = data.howitsworks;


          const mergedCards = [
            {
              card1: data.cards[0]?.card1 || "",
              description1: data.cards[0]?.description1 || "",

              card2: data.cards[1]?.card2 || "",
              description2: data.cards[1]?.description2 || "",

              card3: data.cards[2]?.card3 || "",
              description3: data.cards[2]?.description3 || "",

              card4: data.cards[3]?.card4 || "",
              description4: data.cards[3]?.description4 || "",
            }
          ];

          setFormData({
            howitsworks_id: hw.howitsworks_id,
            language_id: hw.language_id,
            service_id: hw.service_id,
            heading: hw.heading,
            title: hw.title,
            image: hw.image,
            active: hw.active,
            updatedBy: 1,
            cards: mergedCards
          });

          setImagePreview(hw.image);
        }
      })
      .finally(() => setLoading(false));

  }, [id, languageId]);


  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });


  const handleCardChange = (index, field, value) => {
    const newCards = [...formData.cards];
    newCards[index][field] = value;
    setFormData({ ...formData, cards: newCards });
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };


  const handleUpdate = () => {

    if (!formData.heading || !formData.title) {
      return setPopup({
        show: true,
        title: "Warning",
        message: "Please fill all required fields!",
        type: "info",
      });
    }

    const c = formData.cards[0];
    if (!c.card1 || !c.description1 ||
      !c.card2 || !c.description2 ||
      !c.card3 || !c.description3 ||
      !c.card4 || !c.description4) {
      return setPopup({
        show: true,
        title: "Warning",
        message: "Please fill all card titles and descriptions!",
        type: "info",
      });
    }

    setLoading(true);

    if (imageFile) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64Image = reader.result;
        API.post("imageUpload/add", {
          name: imageFile.name,
          image: [{ name: imageFile.name, type: imageFile.type, size: `${imageFile.size} bytes`, base64: base64Image }],
        })
          .then((res) => sendUpdate(res.data?.url))
          .catch(() =>
            setPopup({
              show: true,
              title: "Error",
              message: "Image upload failed!",
              type: "error",
            })
          );
      };
      reader.readAsDataURL(imageFile);
    } else {
      sendUpdate(formData.image);
    }
  };


  const sendUpdate = (imageUrl) => {
    const payload = { ...formData, image: imageUrl };

    API.post("howitsworks_edit/update", payload)
      .then((res) => {

        if (res.data?.success) {
          setPopup({
            show: true,
            title: "Success",
            message: res.data.message || "Updated successfully!",
            type: "success",
          });

          setTimeout(() => navigate(`/services`), 2500);
        } else {
          setPopup({
            show: true,
            title: "Error",
            message: res.data?.message || "Update failed!",
            type: "error",
          });
        }
      })
      .catch((err) => {
        setPopup({
          show: true,
          title: "Error",
          message: "Something went wrong while updating.",
          type: "error",
        });
      })
      .finally(() => setLoading(false));
  };


  const card = formData.cards[0];

  const handlePreview = () => {
    const c = formData.cards[0];


    if (!formData.heading || !formData.title) {
      return setPopup({
        show: true,
        title: "Warning",
        message: "Please fill Heading and Title to preview.",
        type: "info",
      });
    }

    if (!imagePreview) {
      return setPopup({
        show: true,
        title: "Warning",
        message: "Please upload an image before previewing.",
        type: "info",
      });
    }

    if (
      !c.card1 || !c.description1 ||
      !c.card2 || !c.description2 ||
      !c.card3 || !c.description3 ||
      !c.card4 || !c.description4
    ) {
      return setPopup({
        show: true,
        title: "Warning",
        message: "Please complete all 4 card titles and descriptions before preview.",
        type: "info",
      });
    }

    setPreviewData({
      ...formData,
      image: imagePreview,
      howitsworks_id: "preview"
    });

    setShowPreviewHowItWork(true);
  };

  const MAX_CHARS = 2000;

  const [lastValidCardDesc, setLastValidCardDesc] = useState({
    description1: "",
    description2: "",
    description3: "",
    description4: "",
  });
  const handleLimitedCardEditor = (html, field, editor) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    const text = div.textContent || "";

    if (text.length <= MAX_CHARS) {
      // save last valid content
      setLastValidCardDesc(prev => ({
        ...prev,
        [field]: html,
      }));

      // update correct card field
      setFormData(prev => {
        const updatedCards = [...prev.cards];
        updatedCards[0][field] = html;
        return { ...prev, cards: updatedCards };
      });
    } else {
      // restore last valid content (blocks typing, allows backspace)
      editor.setData(lastValidCardDesc[field] || "");
    }
  };



  return (
    <div className="newss-containeradd">

      <div className="service-header-bar">
        <h2>Edit How It Works</h2>

        <div className="button-group">
          <div className="filter-block">
            <label>Language</label>
            <div className="input-container">
              <select
                onChange={(e) => {
                  const newLang = Number(e.target.value);

                  setLanguageId(newLang);


                  const newServiceId = howItWorksServiceMap[newLang];

                  navigate(`/howitworkedit/${newServiceId}?lang=${newLang}`);
                }}

                value={languageId}
                className="input-field"
              >
                <option value={1}>English</option>
                <option value={2}>Français</option>
              </select>
            </div>
          </div>
          <button onClick={handlePreview} className="language-save-btn">
            Preview
          </button>
          <button className="language-save-btn" onClick={handleUpdate}>Save</button>
          <button className="language-cancel-btn" onClick={() => navigate("/services")}>Back</button>
        </div>
      </div>
      {loading ? (
        <Loading />
      ) : (
        <>
          <div className="howitworkedit-container">

            <div className="form-group-services full-width">
              <label>Heading <span className="required">*</span></label>
              <input type="text" name="heading" value={formData.heading} onChange={handleChange} />
            </div>

            {/* LEFT COLUMN */}
            <div className="left-column">
              <div className="form-group-services full-width">
                <label>Title <span className="required">*</span></label>
                <input type="text" name="title" value={formData.title} onChange={handleChange} />
              </div>

              {/* Image */}
              <div className="upload-section">
                <label>Upload Image <span className="required">*</span></label>
                <div className="howitwork-upload-box">
                  {imagePreview ?
                    <img src={imagePreview} className="preview-img" alt="Preview" /> :
                    <>
                      <img src={UploadIcon} className="upload-icon" alt="Upload" />
                      <p>Click to upload</p>
                    </>
                  }
                  <input type="file" accept="image/*" onChange={handleImageUpload} />
                </div>
              </div>

              {/* Card 2 */}
              <div className="form-group-services">
                <div className="form-group-services">
                  <label>Card 2 <span className="required">*</span></label>
                  <input value={card.card2} onChange={(e) => handleCardChange(0, "card2", e.target.value)} />
                </div>
                <div className="form-group-services editor-small">
                  <label className="news-description-label">
                    <span className="label-text">
                      Description <span className="required">*</span>
                    </span>
                    <div className="char-wrapper">
                      <img src={CharIcon} alt="Character count" />
                      <span className="char-count">
                        {getPlainTextLength(card.description2)}/2000
                      </span>
                    </div>
                  </label>
                  <CKEditor
                    editor={ClassicEditor}
                    data={card.description2}
                    onReady={(editor) =>
                      setLastValidCardDesc(prev => ({
                        ...prev,
                        description2: editor.getData(),
                      }))
                    }
                    onChange={(e, editor) =>
                      handleLimitedCardEditor(editor.getData(), "description2", editor)
                    }
                  />

                </div>
              </div>

              {/* Card 4 */}
              <div className="form-group-services">
                <div className="form-group-services">
                  <label>Card 4 <span className="required">*</span></label>
                  <input value={card.card4} onChange={(e) => handleCardChange(0, "card4", e.target.value)} />
                </div>
                <div className="form-group-services editor-small">
                  <label className="news-description-label">
                    <span className="label-text">
                      Description <span className="required">*</span>
                    </span>
                    <div className="char-wrapper">
                      <img src={CharIcon} alt="Character count" />
                      <span className="char-count">
                        {getPlainTextLength(card.description4)}/2000
                      </span>
                    </div>
                  </label>
                  <CKEditor
                    editor={ClassicEditor}
                    data={card.description4}
                    onReady={(editor) =>
                      setLastValidCardDesc(prev => ({
                        ...prev,
                        description4: editor.getData(),
                      }))
                    }
                    onChange={(e, editor) =>
                      handleLimitedCardEditor(editor.getData(), "description4", editor)
                    }
                  />

                </div>
              </div>
            </div>

            {/* RIGHT COLUMN */}
            <div className="right-column">

              {/* Card 1 */}
              <div className="form-group-services">
                <div className="form-group-services">
                  <label>Card 1 <span className="required">*</span></label>
                  <input
                    value={card.card1}
                    onChange={(e) => handleCardChange(0, "card1", e.target.value)}
                  />
                </div>

                <div className="form-group-services editor-small">
                  <label className="news-description-label">
                    <span className="label-text">
                      Description <span className="required">*</span>
                    </span>
                    <div className="char-wrapper">
                      <img src={CharIcon} alt="Character count" />
                      <span className="char-count">
                        {getPlainTextLength(card.description1)}/2000
                      </span>
                    </div>
                  </label>

                  <CKEditor
                    editor={ClassicEditor}
                    data={card.description1}
                    onReady={(editor) =>
                      setLastValidCardDesc(prev => ({
                        ...prev,
                        description1: editor.getData(),
                      }))
                    }
                    onChange={(e, editor) =>
                      handleLimitedCardEditor(editor.getData(), "description1", editor)
                    }
                  />

                </div>
              </div>

              {/* Card 3 */}
              <div className="form-group-services">
                <div className="form-group-services">
                  <label>Card 3 <span className="required">*</span></label>
                  <input value={card.card3} onChange={(e) => handleCardChange(0, "card3", e.target.value)} />
                </div>
                <div className="form-group-services editor-small">
                  <label className="news-description-label">
                    <span className="label-text">
                      Description <span className="required">*</span>
                    </span>
                    <div className="char-wrapper">
                      <img src={CharIcon} alt="Character count" />
                      <span className="char-count">
                        {getPlainTextLength(card.description3)}/2000
                      </span>
                    </div>
                  </label>
                  <CKEditor
                    editor={ClassicEditor}
                    data={card.description3}
                    onReady={(editor) =>
                      setLastValidCardDesc(prev => ({
                        ...prev,
                        description3: editor.getData(),
                      }))
                    }
                    onChange={(e, editor) =>
                      handleLimitedCardEditor(editor.getData(), "description3", editor)
                    }
                  />

                </div>
              </div>
            </div>

          </div>
        </>
      )}
      {popup.show && (
        <div className="popup-overlay">
          <div className={`popup-box popup-${popup.type}`}>
            <h3>{popup.title}</h3>
            <p>{popup.message}</p>
            <div className="popup-buttons">
              <button
                className="btn ok-btn"
                onClick={() => setPopup({ ...popup, show: false })}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
      {showPreviewHowItWork && (
        <HowItWorkPreview
          previewService={previewData}
          setShowPreviewHowItWork={setShowPreviewHowItWork}
        />
      )}

    </div>
  );
};

export default HowItWorkEdit;
